<template>
    <div >
    <div class="container pr-3 pl-3 margin-5" style="padding-bottom: 5rem">
        <div class="mb-lg-5 mb-3 pr-3 pl-3" style="margin-top: 2%">
            <div class=" col-12 logo-side text-center">
                <img class=" mt-md-3 logo-size"
                     src="../assets/logo-login.png">
                &nbsp;
                <span class="text-head">ยินดีต้อนรับ</span>
            </div>
        </div>
        <div class="mt-4 offset-sm-2 col-sm-8 offset-1 col-10">
            <div class="mt-0 menu-form ">
                <div class="row mt-3">
                    <b-button @click="openMainPage" variant="dark"
                              class="offset-lg-1 offset-2 col-lg-4 col-8 btn-form form-group">
                        <img class=" mt-md-3 mb-2 icon-size"
                             src="../assets/report-event-logo.png">
                        <br/>
                        <span >
                            ระบบรายงานเหตุการณ์
                        </span>
                    </b-button>
                    <b-button variant="dark" @click="openDashboard"
                            class="offset-2 col-lg-4 col-8 btn-form form-group">
                        <img class=" mt-md-3 mb-2 icon-size"
                             src="../assets/report-detail-logo.png">
                        <br/>
                        <span>
                            Dashboard
                        </span>
                    </b-button>
                </div>
            </div>
        </div>
    </div>

      <footer-view></footer-view>
<!--        <pre class="alert-danger">{{form}}</pre>-->
<!--        <pre v-if="form.province" class="alert-danger">{{form.province.code}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import FooterView from "./FooterView";
    import {domain_dashboard} from "../util/Constants";
    import moment from "moment";
    // require('../util/cryptojs-aes.min.js');
    // require('../util/cryptojs-aes-format.js');
    import {CryptoJSAesJson} from "../util/cryptojs-aes-format"
    import {CryptoJS} from "../util/cryptojs-aes.min"


    export default {
        name: "MenuView",
      components: {FooterView},
      created(){
            this.checkLogin();
        },
        computed: {
            ...mapState({
                user_login : state=>{
                    return state.Auth.user_login
                }
            })
        },
        data() {
            return {
            };
        },
        methods: {
            checkLogin(){
              if(this.user_login === 1 || this.user_login === null){
                    this.$router.push({
                        name:"LoginView"
                    });
                }
            },
            openMainPage(){
              this.$router.push({
                name:"Status"
              });
            },
          openDashboard(){
            if(this.user_login && this.user_login.user){
              let token = this.user_login.user.user_type_id + ',' + moment().format("YYYY-MM-DD");


              let encryptedJson = this.encrypt(token);
              while(encryptedJson.ct.includes('+')){
                encryptedJson = this.encrypt(token)
              }

              let ct = encryptedJson.ct;
              // let decrypted = CryptoJS.AES.decrypt(encryptedJson, password, { format: CryptoJSAesJson }).toString(CryptoJS.enc.Utf8)
              // console.log('decrypt',decrypted)
              window.open(
                domain_dashboard + '?ct=' + ct + '&iv=' + encryptedJson.iv + '&s=' + encryptedJson.s,
                '_blank' // <- This is what makes it open in a new window.
              );
            }
          },
          encrypt(token){
            let password = 'secret'
            let encrypted = CryptoJS.AES.encrypt(JSON.stringify(token), password, { format: CryptoJSAesJson }).toString()
            return JSON.parse(encrypted)
          }
        }
    }
</script>

<style scoped>
    input[type="file"] {
        display: none;
    }

    .btn-form{
        background-color: #006738;
        color: white;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        border: 0;
        font-size: 24px;
        font-weight: 700;
        letter-spacing: 2px;
        text-align: center;
        padding: 10px;
    }

    .menu-form{
        color: white;
        border: 3px #006738 solid;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        font-weight: 700;
        letter-spacing: 2px;
    }
    .menu-form span{
        font-size: 28px;
    }
    .logo-size{
        height: 140px;
    }

    .icon-size{
        height: 80px;
    }

    .text-head{
        color: #006738;
        font-size: 48px;
    }

    @media only screen and (max-width: 991px) {
        .logo-size{
            height: 100px;
        }

        .text-head{
            font-size: 45px;
        }

    }

    @media only screen and (max-width: 767px) {
        .logo-size{
            height: 125px;
        }

        .text-head{
            font-size: 44px;
        }

    }

    @media only screen and (max-width: 499px) {
        .logo-size{
            height: 80px;
        }

        .text-head{
            font-size: 38px;
        }

    }

</style>
